<!--
 * @Version      : V1.0
 * @Date         : 2025-05-21 13:27:18
 * @fileName     :
 * @Description  : 费用报销详情
-->
<template>
  <el-drawer :title="title" v-loading="loading" :visible.sync="dialogDrawer" direction="rtl" :wrapperClosable="false"
    size="80%" :before-close="closeDrawer">
    <div class="details px-20 py-20 border-box">
      <el-row :gutter="20">
        <el-col :span="18">
          <descriptions v-if="!showDesc" :span="6" :status="status" :row-data="rowData" :rules="rules"
            :columns="columns" ref="descriptionsRef">
            <!--关联项目 -->
            <template #correlationTypeSlot="{ data }">
              <div>
                <el-radio-group v-model="correlationType" :disabled="data.disabled" @input="radioChange">
                  <el-radio :label="i.value" v-for="(i, idx) in data.option" :key="idx">{{ i.label }}</el-radio>
                </el-radio-group>
              </div>
            </template>

            <template #projectSlot="{ data }">
              <div class="flex items-center">
                <div>
                  <!--项目 -->
                  <el-select clearable v-model="projectId" :disabled="data.disabled" v-if="correlationType == '1'"
                    filterable remote reserve-keyword placeholder="请选择项目名称"
                    :remote-method="(e) => remoteMethod(e, 'projectId')" :loading="selectLoading">
                    <el-option v-for="item in projectOptions" :key="item.id" :label="item.projectName"
                      @click.native="curOption(item, data, 'projectId')" :value="item.id">
                    </el-option>
                  </el-select>
                  <!--收款合同 -->

                  <el-select clearable v-model="contractReceivePaymentId" :disabled="data.disabled" v-else filterable
                    remote reserve-keyword placeholder="请选择合同名称"
                    :remote-method="(e) => remoteMethod(e, 'contractReceivePaymentId')" :loading="selectLoading">
                    <el-option v-for="item in receivableContractOption" :key="item.id" :label="item.contractName"
                      @click.native="curOption(item, data, 'contractReceivePaymentId')" :value="item.id">
                    </el-option>
                  </el-select>
                </div>
                <el-button size="small" type="primary" icon="el-icon-view" style="margin-left: 10px;"
                  @click="openViewProject(correlationType == '1' ? projectId : contractReceivePaymentId, correlationType)"
                  v-if="projectId || contractReceivePaymentId">查看</el-button>
              </div>
            </template>
          </descriptions>
          <auditCom v-if="toExamine && dialogDrawer" @refreshInitData="childReviewer"></auditCom>
        </el-col>
        <el-col :span="6">
          <div class="approval-progress">
            <div class="progress-box"  v-if="status !== 'add'">
              <div class="progress-title">审批流程</div>
              <div class="progress-desc-info flex flex-wrap">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item v-for="(item, index) in processDescInfo" :key="index">
                    <div class="items">
                      <el-avatar shape="square" size="large"
                          :src="item ? imageUrlprefix + item : defaultAvatar"></el-avatar>
                    </div>
                  </el-breadcrumb-item>
                </el-breadcrumb>
              </div>
            </div>
            <div class="progress-title" v-if="status !== 'add'">审批进度</div>
            <div class="progress-con" v-if="status !== 'add'">
              <el-timeline>
                <el-timeline-item v-for="(item, index) in processList" :key="index" size="large"
                  :icon="auditProcessStatus(item.auditStatus).icon" :color="auditProcessStatus(item.auditStatus).color">
                  <el-row :gutter="15">
                    <el-col :span="6">
                      <div>
                        <el-image v-if="item.typeLabel == '抄送人'" style="width: 40px;height: 40px;"
                          :src="require('@/assets/makeACopyFor.png')" fit="cover"></el-image>
                        <el-avatar shape="square" v-else size="large"
                          :src="item.avatar ? imageUrlprefix + item.avatar : defaultAvatar"></el-avatar>
                      </div>
                    </el-col>
                    <el-col :span="18" v-if="item.typeLabel == '抄送人'">
                      <div class="makeACopyFor-desc">
                        <div class="makeACopyFor-title">
                          {{ item.typeLabel }}
                        </div>
                        <div class="makeACopyFor-num">
                          已抄送{{ item.userList ? item.userList.length : 0 }}人
                        </div>
                        <div class="makeACopyFor-box flex justify-start items-center flex-wrap">
                          <div class="child-items" v-for="(cItem, cIndex) in item.userList" :key="cIndex">
                            <el-avatar shape="square" size="large"
                              :src="cItem.userAvatar ? imageUrlprefix + cItem.userAvatar : defaultAvatar"></el-avatar>
                            <div class="child-text">{{ cItem.userName }}</div>
                          </div>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="18" v-else>
                      <div class="progress-desc">
                        <div><span>{{ item.name }}</span><span class="progress-time">{{ item.date }}</span></div>
                        <div>{{ item.typeLabel }}</div>
                        <div :style="{ color: auditProcessStatus(item.auditStatus).color, fontSize: '18px' }">{{
                          item.auditLabel }}</div>
                        <div class="signature-box flex justify-start items-center" v-if="item.signatureUrl">
                          <span class="signature-title">签名</span>
                          <el-image class="signature-img" :src="imageUrlprefix + item.signatureUrl"
                            fit="contain"></el-image>
                        </div>
                        <el-tooltip class="item" effect="dark" :content="item.auditComment" placement="top-start">
                          <p class="notes-text" v-if="item.auditStatus == 2 || item.auditStatus == 9">
                            {{ item.auditComment }}
                          </p>
                        </el-tooltip>
                      </div>
                    </el-col>
                  </el-row>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="details-footer px-20 py-20 border-box" v-if="status !== 'view'">
      <el-button type="primary" @click="submit()">提交</el-button>
      <el-button type="primary" @click="temporarilyStore()" v-if="status == 'add' || status == 'edit'">暂存</el-button>
      <el-button @click="clearForm()" v-if="status == 'add' || status == 'edit'">清空</el-button>
    </div>
    <view-other-details ref="viewProjectRef"></view-other-details>
  </el-drawer>
</template>

<script>
import descriptions from '@/components/descriptions/index.vue'
import { queryFinReimbursementDetailsApi, addFinReimbursementApi, editFinReimbursementApi, processFinReimbursementApi, queryAuditProcessDescriptionApi } from '@/api/expenseReimbursement/index'
import { getContractInvoiceAndReceivedDataApi, getProjectsInvoiceAndReceivedDataApi } from '@/api/paymentContract/index'
import { querySupplierInfoListApi, queryBasicOwnersListApi, queryChargeListtApi, queryBasicSuppliersListApi } from '@/api/basicInfo/index'
import { queryPageForLedgerListApi } from '@/api/receivableContract‌/index'
import { auditProcessStatus, conrractCount } from '@/utils/index'
import { queryProjectForLedgerListApi } from '@/api/project/index'
import { dataPage } from "@/api/sys/dictData";
import auditCom from "@/components/auditCom/index.vue"
import viewOtherDetails from "@/components/viewOtherDetails/index.vue"
export default {
  components: {
    descriptions,
    auditCom,
    viewOtherDetails
  },
  props: {
    toExamine: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '费用报销详情'
    },
    status: {
      type: String,
      default: 'view'
    }
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value && /^1[3456789]\d{9}$/.test(value)) {
        callback()
      } else {
        callback(new Error('请输入正确的手机号码'))
      }
    }
    return {
      defaultAvatar: 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png',
      dialogDrawer: false,
      projectId: "",
      contractReceivePaymentId: "",
      correlationType: '1',
      selectLoading: false,
      projectOptions: false,
      loading: false,
      customerForm: {},
      showDesc: false,
      columns: [
        {
          key: 'correlationType', label: '关联类型', span: 6, placeholder: '请选择关联类型', disabled: true, defaultValue: '', slotName: 'correlationTypeSlot', option: [
            { label: '项目', value: '1' },
            { label: '收款合同', value: '2' },
          ]
        },
        // { key: 'projectId', label: '关联对象', span: 6, placeholder: '请选择关联对象', disabled: true, defaultValue: '', slotName: 'projectSlot' },
        { key: 'projectId', label: '关联项目', span: 6, placeholder: '请选择关联项目', disabled: true, defaultValue: '', slotName: 'projectSlot' },
        {
          key: 'relatedItemsReceivePayment', height: 'auto', label: '关联项收款情况', span: 6, placeholder: '', disabled: true, input: 'table', isShowAdd: false,
          columns: [
            { label: '总金额(元)', key: 'totalAmount', width: '120px', align: 'center', placeholder: '请输入阶段', input: 'input', required: true, defaultValue: "" },
            { label: '已开票金额(元)', key: 'invoicedAmount', width: '120px', placeholder: '请输入预计金额', align: 'center', input: 'input', defaultValue: "" },
            { label: '未开票金额(元)', key: 'noInvoicedAmount', width: '120px', placeholder: '请输入预计日期', align: 'center', input: 'date', defaultValue: "" },
            { label: '已收款金额(元)', key: 'receivedAmount', width: '120px', align: 'center', placeholder: '请输入备注', input: 'input', defaultValue: "" },
            { label: '未收款金额(元)', key: 'noReceivedAmount', width: '120px', align: 'center', placeholder: '请输入备注', input: 'input', defaultValue: "" },
          ],
          defaultValue: []
        },
        { key: 'reimbursementAmount', label: '报销金额(元)', span: 3, placeholder: '请输入报销金额', input: 'input-number', type: 'text', disabled: true, defaultValue: '', amountCn: true, amountKeyName: 'reimbursementAmountCn' },
        { key: 'reimbursementAmountCn', label: '报销金额大写', span: 3, placeholder: '请输入报销金额大写', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'payeeName', label: '收款户名', span: 3, placeholder: '请输入收款户名', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'payeeAccountBank', label: '收款账户开户行', span: 3, placeholder: '请输入收款账户开户行', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'payeeAccountCredited', label: '收款账户', span: 6, placeholder: '请输入收款账户', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        {
          key: 'reimbursementItemList', height: 'auto', label: '报销明细', span: 6, placeholder: '', disabled: true, input: 'table', isShowAdd: true,
          columns: [
            { label: '报销类型', key: 'typeCode', width: '120px', align: 'center', placeholder: '请选择报销类型', input: 'select', labelKey: 'dictLabel', valueKey: 'dictValue', required: true, defaultValue: "", required: true, option: [] },
            { label: '费用说明', key: 'feesDescription', width: '120px', placeholder: '请输入费用说明', align: 'center', input: 'input', defaultValue: "", required: true, },
            { label: '金额(元)', key: 'amount', width: '120px', placeholder: '请输入金额', align: 'center', input: 'input', defaultValue: "", required: true, },
            { label: '备注', key: 'notes', width: '120px', align: 'center', placeholder: '请输入备注', input: 'input', defaultValue: "" },
          ],
          defaultValue: []
        },
        { key: 'attachment', height: '450px', label: '附件', span: 6, placeholder: '请上传附件上传', uploadType: 'project', input: 'upload', fileMaxSize: 200, disabled: true, defaultValue: [], accept: '.xls,.xlsx,.pdf,.doc,.docx,.txt,.bmp,.jpg,.jpeg,.png,.tif,.gif,.svg,.webp,.zip,.rar,.7z', limit: 50, },
        { key: 'notes', label: '备注', span: 6, placeholder: '请输入备注', input: 'textarea', type: 'textarea', disabled: true, defaultValue: '' },
      ],
      rowData: {},
      cloneColumns: [],//复制一遍
      rules: {
        reimbursementItemList: [],
        payeeName: [
          { required: true, message: '请输入收款户名', trigger: 'blur' },
        ],
        payeeAccountBank: [
          { required: true, message: '请输入收款账户开户行', trigger: 'blur' },
        ],
        payeeAccountCredited: [
          { required: true, message: '请输入收款账户', trigger: 'blur' },
        ],
        correlationType: [],
        projectId: []
      },
      processList: [],
      processDescInfo: [],
      receivableContractOption: []
    }
  },
  mounted() {
    this.dictOption('project_type');
    this.dictOption('reimbursement_item_type');
    this.getLedgerProjectList();
    this.getLedgerContractList();
    this.cloneColumns = JSON.parse(JSON.stringify(this.columns))
  },
  methods: {
    auditProcessStatus,
    //核心方法 判断是否是新增 还是编辑
    async openDrawer(row) {
      this.dialogDrawer = true;
      this.projectId = row.projectId;
      this.$nextTick(() => {
        switch (this.status) {
          case 'view':
            this.queryDetails({ id: row.id })
            break;
          case 'add':
            //新增把原有的数据设置默认值
            this.showDesc = true;
            for (let i = 0; i < this.columns.length; i++) {
              this.columns[i].disabled = false;
              this.columns[i].defaultValue = this.cloneColumns[i].defaultValue;
            }
            this.$nextTick(() => {
              this.showDesc = false;
            })
            this.reverseDisplayList({}, 'projectId')
            break;
          case 'edit':
            this.queryDetails({ id: row.id })
            break;
          case 'change':
            this.queryDetails({ id: row.id })
            break;
          default:
            break;
        }
      })
    },
    //关闭弹框
    closeDrawer() {
      this.dialogDrawer = false;
      this.projectId = "";
      this.contractReceivePaymentId = "";
      this.correlationType = '1';
    },
    //详情查询
    queryDetails(params) {
      this.loading = true;
      this.showDesc = true;
      queryFinReimbursementDetailsApi(params).then(res => {
        this.loading = false;
        this.showDesc = false;
        if (res.code == 200) {
          this.rowData = res.data;
          if (this.status !== 'add') {
            this.projectId = res.data.projectId;
            this.contractReceivePaymentId = res.data.contractReceivePaymentId;
            this.correlationType = res.data.correlationType;
            for (let i = 0; i < this.columns.length; i++) {
              this.columns[i].disabled = this.status == 'view' ? true : false;
              if (this.columns[i].key == 'relatedItemsReceivePayment') {
                if (res.data.correlationType == 1) {
                  this.reverseDisplayList({ id: res.data.projectId }, 'projectId')
                } else {
                  this.reverseDisplayList({ id: res.data.contractReceivePaymentId }, 'contractReceivePaymentId')
                }

              } else {
                this.columns[i].defaultValue = this.rowData[this.columns[i].key];
                this.projectId = this.rowData.projectId;
              }

            }
          }


        }
      })
      this.queryProcessProject(params)
      this.qeuryAuditProcessDescription(params)
    },
    //提交
    submit(status = 1) {
      this.$refs.descriptionsRef.submit().then((formData = {}) => {
        if ('relatedItemsReceivePayment' in formData) {
          delete formData.relatedItemsReceivePayment
        }
        let params = {
          reimbursementStatus: status,
          ...formData,
          correlationType: this.correlationType,
        }
        if (params.correlationType == '1') {
          params['projectId'] = this.projectId;
        } else {
          params['contractReceivePaymentId'] = this.contractReceivePaymentId;
        }
        this.loading = true;
        if (this.status == 'add') {
          addFinReimbursementApi(params).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
            this.loading = false;
            this.closeDrawer();
            this.queryData();
          }).catch(err => {
            this.loading = false;
          })
        } else {
          editFinReimbursementApi(params).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            }
            this.loading = false;
            this.closeDrawer();
            this.queryData();
          }).catch(err => {
            this.loading = false;
          })
        }

      })
    },
    //暂存
    temporarilyStore() {
      this.submit(0);
    },
    //清空描述组件form
    clearForm() {
      this.projectId = "";
      this.$refs.descriptionsRef.resetForm()
    },
    //查询列表
    queryData() {
      this.$emit('initQueryData')
    },
    async dictOption(type) {
      let params = {
        query: {
          dictType: type
        }
      }
      dataPage(params).then(res => {
        if (res.code == 200) {
          this.columns.map(item => {
            if (item.key == 'projectTypeCode' && type == 'project_type') {
              item.option = res.data.rows || []
            } else if (item.key == 'reimbursementItemList' && type == 'reimbursement_item_type') {
              item.columns[0].option = res.data.rows || []
            }
            return item
          })
        }
      })
    },
    //查询项目台账
    getLedgerProjectList(v = '') {
      let params = {
        params: {
          projectCode: "",
          projectName: v,
        }
      }
      this.selectLoading = true;
      queryProjectForLedgerListApi(params).then(res => {
        this.selectLoading = false;
        if (res.code == 200) {
          this.projectOptions = res.data;
        }
      })
    },
    //查询收款合同台账
    getLedgerContractList(v = '') {
      let params = {
        params: {
          contractName:v,
        }
      }
      this.selectLoading = true;
      queryPageForLedgerListApi(params).then(res => {
        this.selectLoading = false;
        if (res.code == 200) {
          this.receivableContractOption = res.data;
        }
      })
    },
    // 通过合同-获取开票和收款数据
    getInvoiceAndReceivedDataContract(id) {
      let params = {
        id,
      }
      getContractInvoiceAndReceivedDataApi(params).then(res => {
        if (res.code == 200) {
          this.columns.map(item => {
            if (item.key == 'relatedItemsReceivePayment') {
              item.defaultValue = res.data ? [res.data] : [] || []
            }
            return item
          })
        }
      })
    },
    // 通过项目-获取开票和收款数据
    getInvoiceAndReceivedDataProjects(id) {
      let params = {
        id,
      }
      getProjectsInvoiceAndReceivedDataApi(params).then(res => {
        if (res.code == 200) {
          this.columns.map(item => {
            if (item.key == 'relatedItemsReceivePayment') {
              item.defaultValue = res.data ? [res.data] : [] || []
            }
            return item
          })
        }
      })
    },
    remoteMethod(query, current = '') {
      
      if (query !== '') {
        switch (current) {
          case 'projectId':
            this.getLedgerProjectList(query)
            break;
          case 'contractReceivePaymentId':
            
            this.getLedgerContractList(query)
            break;
          default:
            break;
        }
      } else {
        this.projectOptions = [];
        this.receivableContractOption = [];
      }
    },
    queryProcessProject(params) {
      processFinReimbursementApi(params).then(res => {
        if (res.code == 200) {
          this.processList = res.data;
        }
      })
    },
    qeuryAuditProcessDescription(params) {
      queryAuditProcessDescriptionApi(params).then(res => {
        if (res.code == 200) {
          this.processDescInfo = res.data.avatars;
        }
      })
    },
    curOption(v = {}, slotData, current) {
      let item = v;
      if (this.status == 'add' || this.status == 'edit' || this.status == 'change') {
        for (let i = 0; i < this.columns.length; i++) {
          for (let key in item) {
            if (this.columns[i].key == key && !this.columns[i].slotName) {
              // if(this.columns[i].key == ''){
              //   this.columns[i].defaultValue = item[this.columns[i].key];
              // }

              this.columns[i].disabled = false;

            }
          }
        }
      }
      this.reverseDisplayList(v, current)
    },
    //关联收款情况反显
    reverseDisplayList(data = {}, current) {

      if (current) {
        if (current == 'projectId' && data.hasOwnProperty('id')) {
          this.getInvoiceAndReceivedDataProjects(data.id)
        } else if (current == 'contractReceivePaymentId' && data.hasOwnProperty('id')) {
          this.getInvoiceAndReceivedDataContract(data.id)
        } else {
          this.columns.map(item => {
            if (item.key == 'relatedItemsReceivePayment') {
              item.defaultValue = [
                {
                  totalAmount: '--',
                  noInvoicedAmount: '--',
                  noReceivedAmount: '--',
                  receivedAmount: '--',
                  invoicedAmount: '--'
                }
              ]
            }
            return item
          })
        }
      }
    },
    //关闭详情 刷新页面
    childReviewer(row) {
      this.closeDrawer()
      this.$emit('parReviewer')
    },
    radioChange() {
      this.projectId = "";
      this.contractReceivePaymentId = "";
    },
    openViewProject(id, correlationType) {
      this.$refs.viewProjectRef.viewProject(id, correlationType)
    }
  }
}
</script>

<style scoped lang="scss">
.details-footer {
  height: 50px;
  line-height: 50px;
  text-align: right;
}

.progress-box{
  padding: 5px;
  box-sizing: border-box;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  border-radius: 5px;
  margin-bottom: 5px;
  background: #285af1;
  .progress-title {
    font-size: 18px;
    padding-bottom: 10px;
    color: #fff;
  }
  .progress-desc-info {
    padding: 10px 0px 10px 0px;

    .items {
      font-size: 15px;
      display: inline-block;
      vertical-align: middle; 
    }
  }
}
.approval-progress {
  

  .progress-title {
    font-size: 18px;
    padding-bottom: 10px;
  }

  .progress-con {
    .progress-desc {
      line-height: 20px;
      color: #303133;

      .progress-time {
        margin-left: 10px;
        color: #909399;
      }

      .notes-text {
        display: -webkit-box;
        /* 设置为弹性盒子模型 */
        -webkit-box-orient: vertical;
        /* 垂直排列 */
        -webkit-line-clamp: 2;
        /* 显示最多 3 行 */
        overflow: hidden;
        /* 隐藏超出的部分 */
        text-overflow: ellipsis;
        /* 使用省略号 */
      }

      .signature-box {
        width: 180px;
        height: 50px;
        overflow: hidden;

        .signature-title {
          display: block;
          width: 40px;
        }

        .signature-img {
          margin-left: 10px;
          width: 180px;
        }
      }
    }

    .makeACopyFor-desc {
      line-height: 20px;
      color: #303133;

      .makeACopyFor-title {}

      .makeACopyFor-num {
        color: #909399;
      }

      .makeACopyFor-box {
        .child-items {
          padding-right: 5px;
          box-sizing: border-box;

          .child-text {
            text-align: center;
          }
        }
      }
    }
  }
}

::v-deep .el-drawer__header {
  color: #000;
  font-size: 18px;
}

::v-deep .el-breadcrumb__separator {
  color: #fff;
}
</style>
